<div *ngIf="!isPublished" class="flex justify-between">
  <div
    class="flex px-3 space-x-4"
    *ngFor="let nextState of allowableNextStates"
  >
    <button
      mat-button
      class="w-64 text-lg font-semibold h-11"
      *ngIf="!nextState.previousStateTransitionMustBeBySameUser"
      color="primary"
      (click)="onChangeState(nextState.status)"
      [disabled]="isProcessingStateChange || isSaving || form.dirty"
      mat-raised-button
      data-testid="stateButton"
    >
      {{
        isProcessingStateChange && selectedState === nextState.status
          ? "Processing..."
          : nextState.stateTransitionAction
      }}
    </button>
  </div>
</div>

<div
  *ngIf="isPublished && !isSpiked && canCreateNewVersion$ | async"
  class="flex justify-between"
>
  <div class="flex px-3 space-x-4">
    <button
      mat-button
      class="w-64 text-lg font-semibold h-11"
      color="primary"
      (click)="onReEdit()"
      [disabled]="isProcessingStateChange || isSaving || form.dirty"
      mat-raised-button
      data-testid="stateButton"
    >
      {{ isProcessingStateChange ? "Processing..." : "Re-Edit" }}
    </button>
  </div>
</div>

<div *ngIf="isSpiked" class="flex justify-between">
  <div class="flex px-3 space-x-4">
    <button
      mat-button
      class="w-64 text-lg font-semibold h-11"
      color="primary"
      (click)="onReactivate()"
      mat-raised-button
      data-testid="reactivateButton"
    >
      {{ isProcessingStateChange ? "Processing..." : "Reactivate" }}
    </button>
  </div>
</div>
